import mpx from '@mpxjs/core'
import { sendXspmScan, sendXspmClick, xenv } from '@didi/webx-js'
import { goodsClick } from '@/lib/js/goods_webx'
import { GlobalEnv, sendRecOrderRequest, URLQueries } from '@/lib/webx'
import { request } from '@/lib/webx/api'
import { GlobalConfig } from '@/lib/webx/config'
import { EnumGoodsType } from '@/lib/webx/defines'
import { getErrorMessage } from '@/lib/webx/utils/error'
import { xspmMap } from '@/lib/js/util'
import { getParamsPartitionIdByXenv } from '@/lib/webx/global_env/partition_id'
import {
  MASErrorTrackAlgorithmTrackError,
  MASErrorTrackLoadGoodsListError,
} from '@/lib/webx/mas_error_track'
import { isDyProgramH5 } from '@/lib/js/env'

const isExternalGoods = goods => {
  return !!goods?.link_url || goods?.goods_type === EnumGoodsType.Carpool
}

const addGoodsShowBpoint = (goods = {}, event) => {
  try {
    if (event && event.event_url) {
      const params = Object.assign({}, event.event_info, {
        item_id: goods.goods_id,
        expose_page: goods.algorithmEventPageInfo.page,
        expose_pos: goods.algorithmEventPageInfo.index,
        event_type: 'sw',
        event_time: Date.now(),
      })
      sendRecOrderRequest(params, event.event_url)
    }
    const _params = {
      uid: GlobalEnv.loginInfo.uid,
      goods_id: goods.goods_id,
      workflow_id:
        event && event.event_info ? event.event_info.workflow_id : -1,
      is_free: goods?.credit_info?.status,
      product_type: goods.product_type,
      package_type: goods?.is_spike,
      route_type: goods?.route_type,
      city_id: GlobalEnv.locationInfo?.cityId,
      tab_id: goods.cate_id,
      is_dim_p: goods.is_dim_p,
    }
    window.mallTrackEvent(
      'c_trippackage_mall_landpage_goods_sw',
      '每个具体商品曝光的PV、UV',
      _params
    )
    if (goods.goods_type === EnumGoodsType.Carpool) {
      // const fr = xenv()
      // priority 76 是畅拼卡，77 是省钱卡。畅拼卡埋1，省钱卡埋2
      // const type = goods.priority === 76 ? 1 : 2
      window.mallTrackEvent(
        'wyc_mall_pinchecard_sw',
        '优惠商城推荐位-畅拼卡展现',
        {
          fr: xenv(),
          pg_type: 3,
          type: goods.priority,
          uid: GlobalEnv.loginInfo.uid,
          ...(goods?.omega_info || {}),
        }
      )
    }
  } catch (error) {
    const msg = getErrorMessage(error, {
      friendly: false,
    })
    MASErrorTrackAlgorithmTrackError(msg, error)
  }
}

export const MixinList = {
  attached() {
    // 滚动加载
    this.observer = new IntersectionObserver(entries => {
      entries.forEach(async entry => {
        if (
          entry.isIntersecting &&
          (entry.boundingClientRect?.y > entry.rootBounds?.height / 2 ||
            !entry.rootBounds)
        ) {
          if (this.isLoadingNextPage) return
          this.isLoadingNextPage = true
          await this.loadMore()
          this.isLoadingNextPage = false
        }
      })
    })
  },
  detached() {
    this.observer.disconnect()
  },
  data: {
    isLoadingNextPage: false,
    algorithmEvent: {
      event_url: '',
      event_info: '',
    },
  },
  methods: {
    async $getGoodsByCates(cateId, page) {
      try {
        const params = {
          source_id: GlobalEnv.channelId,
          token: GlobalEnv.loginInfo.token,
          city_id: GlobalEnv.locationInfo.cityId,
          lat: GlobalEnv.locationInfo.lat,
          lng: GlobalEnv.locationInfo.lng,
          cate_id: cateId,
          origin: 'h5',
          terminal: GlobalEnv.terminal,
          page,
          size: 10,
          partition_id: getParamsPartitionIdByXenv(),
          xenv: xenv(),
        }
        // 抖音的情况， 传 show_channel
        if (isDyProgramH5()) {
          params.show_channel = 20
        }
        const { lists, event_url, event_info, count } = await request.get(
          GlobalConfig.APIs.goodsList,
          params
        )
        if (event_url && event_info) {
          this.algorithmEvent.event_url = event_url
          this.algorithmEvent.event_info = event_info
        }
        lists.forEach((goods, index) => {
          Object.assign(goods, {
            algorithmEventPageInfo: {
              page,
              index,
            },
          })
          addGoodsShowBpoint(goods, this.algorithmEvent)
          if (isExternalGoods(goods)) {
            sendXspmScan(
              {},
              {
                a: xspmMap.key,
                b: xspmMap.externalGoods.b,
                c: xspmMap.externalGoods.c,
                d: '',
              }
            )
          }
        })
        return {
          lists,
          count,
        }
      } catch (error) {
        // mpx.showModal({
        //   content: this.$t('home.goodsLoadingFail') || getErrorMessage(error),
        //   title: '错误',
        // })
        mpx.showToast({
          title: this.$t('home.goodsLoadingFail'),
          icon: 'none',
        })
        const msg = getErrorMessage(error, {
          friendly: false,
        })
        MASErrorTrackLoadGoodsListError(msg, error)
      }
    },
    observeSentinel() {
      this.$refs.sentinel?.[0] &&
        this.observer.unobserve(this.$refs.sentinel[0])
      this.$nextTick(() => {
        this.$refs.sentinel?.[0] &&
          this.observer.observe(this.$refs.sentinel[0])
      })
    },
    onGoodClick(goods) {
      if (isExternalGoods(goods)) {
        sendXspmClick(
          {},
          {
            a: xspmMap.key,
            b: xspmMap.externalGoods.b,
            c: xspmMap.externalGoods.c,
            d: '',
          }
        )
      }
      goodsClick(
        goods,
        {
          source: 'landpage',
          trip_cityid: URLQueries.getQuery('trip_cityid'),
          access_key_id: URLQueries.getQuery('access_key_id'),
        },
        this.algorithmEvent
      )
    },
  },
}
